import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Link, Text } from '@beef/ui-kit';
import { Picture } from 'components';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const DescriptionBlock = ({
  description, amountIcon, amount, amountUnit, btnLink, btnText,
}) => (
  <div className={cn('description-block')}>
    {description && (
      <div className={cn('description-block__description')}>
        <Text size="size7-r" color="grey60">{description}</Text>
      </div>
    )}
    <div className={cn('description-block__amount')}>
      {amountIcon && (
        <Picture
          defaultImage={amountIcon}
          className={cn('amount__icon')}
          alt=""
        />
      )}
      {amount && (
        <span className={cn('amount__price')}>
          <Text size="size5-m">
            {amount}
          </Text>
        </span>
      )}
      {amountUnit && (
        <span className={cn('amount__unit')}>
          <Text size="size5-m">
            {amountUnit}
          </Text>
        </span>
      )}
    </div>
    <div className={cn('description-block__button')}>
      <Link
        href={btnLink}
        isFullWidth
        variant="button"
        buttonVariant="main"
        buttonSize="s"
      >
        {btnText}
      </Link>
    </div>
  </div>
);

DescriptionBlock.propTypes = {
  description: PropTypes.string,
  amount: PropTypes.number,
  amountIcon: PropTypes.string,
  amountUnit: PropTypes.string,
  btnLink: PropTypes.string,
  btnText: PropTypes.string,
};

export { DescriptionBlock };
